import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL as string;

export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });
export const publicApi = axios.create({ baseURL: API, timeout: 30000 });

let refreshing: Promise<any> | null = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url: string = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (_) {
        /* fall through */
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e: any): string {
  if (e?.code === "ECONNABORTED") return "The request timed out. Check your connection and try again.";
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? "Something went wrong. Please try again." : "Network error. Check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x?.msg || "").replace("Value error, ", "")).filter(Boolean).join(" ");
  return d.message || "Something went wrong.";
}

export const errCode = (e: any): string | undefined => e?.response?.data?.detail?.code;
export const errList = (e: any): string[] => e?.response?.data?.detail?.errors || [];

export const money = (cents?: number | null) =>
  cents == null ? "—" : `$${(cents / 100).toLocaleString("en-US", { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;

export const sqft = (v?: string | number | null) =>
  v == null || v === "" ? "—" : `${Math.round(Number(v)).toLocaleString("en-US")} sq ft`;

export const fmtDate = (iso?: string) => (iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");

export function readableText(hex?: string): string {
  const h = (hex || "#0F766E").replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) / 255).map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return L > 0.4 ? "#0f172a" : "#ffffff";
}
